import React from 'react';

import { Form, Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import Label from 'components/shared/FormAdapters/FormDefault/Label';
import LabelWrapper from 'components/shared/FormAdapters/FormDefault/Label/Wrapper';
import Loader from 'components/shared/Loader';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import UnsavedChangesFormWatcher from 'components/shared/UnsavedChangesFormWatcher';
import { pageDataSelector } from 'store/page/selectors';
import { capitalizeAllWordsForInput } from 'utils/common';
import generateHandleValue from 'utils/form/mutators/generateHandleValue';

import { BuilderFooterButton } from '../../shared/BuilderFooterButton';
import { usePageContext } from '../../shared/context';
import PageFormButtons from '../../shared/PageFormButtons';
import { useHelpArticleDetails } from './functions';

function Details() {
  const page = useSelector(pageDataSelector);
  const { useNextStepFormHandler } = usePageContext();
  const handleNextStep = useNextStepFormHandler();
  const { validate } = useHelpArticleDetails();

  return (
    <Form
      onSubmit={handleNextStep}
      initialValues={page}
      validate={validate}
      mutators={{
        generateHandleValue,
      }}
      render={({ handleSubmit, submitting, invalid }) => (
        <form onSubmit={handleSubmit} autoComplete="nope">
          <UnsavedChangesFormWatcher />

          {submitting && <Loader isFillBlock />}
          <FormTitle center>{page.id ? 'Edit Page Content' : 'Create New Content'}</FormTitle>

          <FormTitle hint="Enter information to organize this content so that you can find it easily later.">
            I. Page Details
          </FormTitle>

          <LabelWrapper>
            <Label>Page Name</Label>
            <Text accent>The name of a page will appear throughout the client facing itinerary.</Text>
          </LabelWrapper>
          <Field
            component={FormGroupAdapter}
            name="name"
            placeholder="Creating New Content"
            type="text"
            onInput={capitalizeAllWordsForInput}
          />

          <LabelWrapper>
            <Label>Tags</Label>
            <Text accent>Tags make it easier to find and categorize content.</Text>
          </LabelWrapper>
          <Field component={FormGroupAdapter} name="tags" placeholder="Help" type="tags" />

          <Field
            component={FormGroupAdapter}
            name="articleDescription"
            placeholder="The Internet is a visual medium and images play a crucial role in your site's design, message, and content. In the videos below, we'll explore why images matter, discuss guidelines for formatting..."
            type="textarea"
            label="Article Description"
            minRows={8}
          />

          <FormActions isRight>
            <BuilderFooterButton htmlType="submit" disabled={submitting || invalid}>
              Next
            </BuilderFooterButton>
          </FormActions>

          <PageFormButtons />
        </form>
      )}
    />
  );
}

export default Details;
